import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import LandActionsDt from '@/services/dataTransferModules/landActionsDt'

export default function useLandActions(params = {}) {
	const landActionDt = new LandActionsDt()

	const { t: $t } = useI18n()

	const defaults = {
		fieldsCreating: {
			name: '',
		},
		fieldsToPatch: [
			'name',
		],
	}

	const {
		loadEntityFlags: flags,

		entities: landActions,
		getEntities: getLandActions,

		createEntity: createLandAction,

		entity: landAction,
		getEntity: getLandAction,

		entityPopup: landActionPopup,
		getEntityPopup: getLandActionPopup,

		entityPreview: landActionPreview,
		getEntityPreview: getLandActionPreview,

		patchEntity: patchLandAction,
		updateEntity: putLandAction,

		deleteEntity: deleteLandAction,
	} = useBlProviders(
		landActionDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Error when loading planned land actions'),

				showErrorNotificationForCreatingEntity: true,
				errorNotificationTextForCreatingEntity: $t('Error when creating a planned land action'),

				showErrorNotificationForLoadingOneEntity: true,
				errorNotificationTextForLoadingOneEntity: $t('Error loading scheduled land action'),

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Error when editing the planned action of a land plot'),

				showErrorNotificationForDeletingEntity: true,
				errorNotificationTextForDeletingEntity: $t('Error when deleting a planned action of a land plot'),
			},
			params,
		),
	)

	return {
		flags,
		landActions,
		landAction,
		landActionPreview,
		landActionPopup,
		defaults,

		getLandActions,
		getLandAction,
		getLandActionPreview,
		getLandActionPopup,
		createLandAction,
		putLandAction,
		patchLandAction,
		deleteLandAction,
	}
}
